import React, { useEffect, useState } from "react";
import ReactCodeInput from "react-code-input";
import { useForm } from "react-hook-form";
import Button from "../../shared/Button";
import Input from "../../shared/Input";
import refresh from "../../../assets/img/icons/rotate-left.svg";
import Countdown, { CountdownApi } from "react-countdown";
import axios from "axios";
import { API_URL } from "../../../constants";
import { toast } from "react-hot-toast";
import { useAuth } from "../../../context/authContext";
import { useNavigate } from "react-router-dom";
import BeatLoader from "react-spinners/BeatLoader";
import { useUserInfo } from "../../../context/UserContext";

const PhoneNumberConfirm = ({ setStep, phoneNumber, setPhoneNumber }) => {
  const { control, handleSubmit, formState: { errors, isValid } } = useForm({
    mode: "onChange",
    reValidateMode: "onChange"
  });
  const [codevalue, setcodevalue] = useState("");
  const [tabIndex, settabIndex] = useState(0);
  const [loading, setloading] = useState(false);
  const [running, setRunning] = useState(true);

  const { authDispatch, authRefreshDispatch } = useAuth();
  const {getUser} = useUserInfo()

  const onSubmit = () => {
  };
  const navigate = useNavigate();
  const props = {
    className: "reactCodeInput",
    inputStyle: {
      width: "83px",
      height: "84px",
      borderRadius: "20px",
      fontSize: "20px",
      marginRight: "14px",

      backgroundColor: "transparent",
      color: "#313E45",
      border: "2px solid #DADFE1",
      textAlign: "center"
    }
  };
  //bearer_token: "3|xqFNViOvjbvxNDWx05pZ3RVerDBkGygl4Aty6sbJ"

  const sendpattern = () => {
    // axios.defaults.withCredentials = true

    axios({
      method: "get",
      url: `${API_URL}/sanctum/csrf-cookie`
    }).then(function(res) {
      console.log(res)
      axios({
        method: "post",
        url: `${API_URL}/api/auth/send-pattern`,
        data: phoneNumber,
        headers: { "Content-Type": "multipart/form-data",
       
      }
      })
        .then(function(res) {
          toast.success(res.data.data.notification_data.original.message);
        })
        .catch(function(response) {
          console.log(response);
        });
    });
  };

 
  useEffect(() => {
    sendpattern();
  }, []);
  console.log(codevalue);

  const sendCode = () => {
    setloading(true);
    axios({
      method: "get",
      url: `${API_URL}/sanctum/csrf-cookie`
    }).then(function(res) {
      axios({
        method: "post",
        url: `${API_URL}/api/auth/validate`,
        data: {
          code: codevalue,
          phone: phoneNumber.phone
        },
        headers: { "Content-Type": "multipart/form-data" }
      })
        .then(function(res) {
          if (res.data.message === "کد ارسالی شما درست است .") {
            authDispatch({
              type: "LOGIN",
              token: res.data.data.bearer_token
            });
            setloading(false);
           
            navigate("/");
         

          }
        })
        .catch(function(err) {
          if (
            err.response.data.message ===
            "کد ارسال شده با کد شما مطابقت ندارد ."
          ) {
            toast.error("کد ارسال شده با کد شما مطابقت ندارد .");
          }
          setloading(false);
        });
    });
  };
  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="PhoneRegister CodeRagister__back">
      <h2>تایید شماره تماس</h2>
        <p className="register-sub">
          به وبسایت جاتیک خوش آمدید کد 5 رقمی ارسال‌شده به شماره ”{phoneNumber.phone}”
          را واردکنید.
        </p>

        <div className="d-flex-align resendagain">
          ارسال مجدد کد تایید تا
          <span>
            {" "}{" "}
            {running
              ? <Countdown
                  zeroPadTime={2}
                  date={Date.now() + 120000}
                  autoStart={running}
                  onComplete={()=>setRunning(false)}
                  renderer={({ hours, minutes, seconds, completed }) => {
                    return (
                      <span>
                        0{minutes}:{seconds}
                      </span>
                    );
                  }}
                />
              : <span
                  className="cursor-pointer"
                  onClick={() => {
                    sendpattern();
                    setRunning(true);
                  }}
                >
                  ارسال مجدد
                </span>}
            {/* <Countdown
            date={Date.now() * 20000}
            precision={3}
            autoStart={running}
            renderer={({ hours, minutes, seconds, completed }) => {
              return (
                <span>
                  {hours}:{minutes}:{seconds}
                </span>
              );
            }}
          /> */}
          </span>
          دیگر امکان پذیر است
        </div>
        <div className="flex items-center my-[20px]">
          <div className="refresh-code center cursor-pointer">
            <img src={refresh} />
          </div>
          <div className="">
            <ReactCodeInput
              value={codevalue}
              onChange={e => setcodevalue(e)}
              fields={5}
              {...props}
            />
          </div>
        </div>
      </div>
     <div className="flex items-center gap-[20px]">
     <div
        className="button__thirdbtn button"
        onClick={() => setStep(1)}
      >
        ویرایش شماره تماس
      </div>
      <Button
        varient="primary"
        disabled={codevalue.length < 5}
        onClick={() => sendCode()}
        type='submit'
        tabIndex={1}
      >
        {loading
          ? <BeatLoader
              color="#36d7b7"
              size={10}
              aria-label="Loading Spinner"
              data-testid="loader"
            />
          : "تایید کد و ادامه"}
      </Button>
     </div>
    </form>
  );
};

export default PhoneNumberConfirm;
